const SET = 'randomNo/SET'

export const setRandomNo = () => {
  return {
    type: SET,
  }
}

const getRandomNo = (): number => {
  return Math.floor(Math.random() * 100)
}

export default (state = getRandomNo(), action) => {
  switch (action.type) {
    case SET:
      return getRandomNo()
    default:
      return state
  }
}
